import { Intent } from "@blueprintjs/core";

import { ID } from "common/entities/IEntity";

// object received from dictionaryEntries query
export interface IDictionaryEntry {
	id?: ID;
	key: string;
	language: string;
	instance?: string;
	value?: string;
	type?: string;
}

export interface IDictionaryRemoveParams {
	key: string;
	language: string | null;
	instance: string | null;
}

// LabelProvider item args
export interface ILabelDefinition {
	k: string; // label key
	v: string; // default value
	argNames?: string[];
	args?: {
		[key: string]: string | number | null | undefined;
	};
	allowMarkdown?: boolean;
	allowHtml?: boolean;
	type?: string;
	instances?: string[];
}

export interface IIntentLabel extends ILabelDefinition {
	intent: Intent;
}

export class LabelRegistry {

	private static registry = {};

	public static register(labelDef: ILabelDefinition): boolean {
		if (!this.registry[labelDef.k]) {
			this.registry[labelDef.k] = labelDef;
			return true;
		}
		return false;
	}

	public static getAll(): ILabelDefinition[] {
		return Object.values(this.registry);
	}

}



// WEBPACK FOOTER //
// ./src/core/components/label/ILabel.ts